import { Component, computed, input, signal } from '@angular/core';
import { ImagePreviewComponent } from 'app/shared/form/image-preview/image-preview.component';
import { Utils } from 'app/shared/utils';
import { IPreviewUrls } from "app/shared/form/file.model";

@Component({
  selector: 'app-images-slider',
  standalone: true,
  imports: [ImagePreviewComponent],
  templateUrl: './images-slider.component.html',
  styleUrls: ['./images-slider.component.scss'],
  host: {
    class: 'block',
  },
})
export class ImagesSliderComponent {
  isDraft = input(false)
  date = input<string>('')
  images = input<IPreviewUrls[]>([]);
  isOverview = input(false);
  itemsPerPage = 2;

  pages = computed(() => [...Array(Math.round(this.images().length / this.itemsPerPage)).keys()].map((i) => i + 1));
  currentPage = signal(1);
  currentPageImageUrls = computed(() => Utils.getPaginatedItems(this.images(), this.itemsPerPage, this.currentPage()));

  isPageActive(page: number): boolean {
    return page === this.currentPage();
  }
  goPage(page: number) {
    this.currentPage.set(page);
  }
}
